import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyDto } from './al-company-v2.service';

export interface CompanyAccessRequestDto {
	id: number;
	companyId: number;
	userId: number;
}

export interface CompanyAccessRequestUpdateDto {
	id: number;
	companyId: number;
	userId: number;
}

@Injectable({
	providedIn: 'root'
})
export class AlCompanyAccessRequestV2Service {
	url: string = 'v2/companyaccessrequests';

	constructor(private http: HttpClient) {}

	// CRUD start
	public getAll(): Observable<CompanyAccessRequestDto[]> {
		return this.http.get<CompanyAccessRequestDto[]>(`${this.url}`);
	}

	public get(companyId: number): Observable<CompanyAccessRequestDto> {
		return this.http.get<CompanyAccessRequestDto>(`${this.url}/${companyId}`);
	}

	public put(company: CompanyAccessRequestUpdateDto): Observable<CompanyAccessRequestDto> {
		return this.http.put<CompanyAccessRequestDto>(`${this.url}/${company.id}`, company);
	}
	// CRUD end

	public approve(request: CompanyAccessRequestDto): Observable<void> {
		return this.http.post<void>(`${this.url}/${request.id}/approve`, undefined);
	}

	public reject(request: CompanyAccessRequestDto): Observable<void> {
		return this.http.post<void>(`${this.url}/${request.id}/reject`, undefined);
	}

	public getAllPotentialUsers(): Observable<[]> {
		return this.http.get<[]>(`${this.url}/potentialUsers`);
	}

	public getAllPotentialCompanies(): Observable<CompanyDto[]> {
		return this.http.get<CompanyDto[]>(`${this.url}/potentialCompanies`);
	}
}
